
import { formatDate } from "@/mixins/shared";
import Vue from "vue";

export default Vue.extend({
  name: "SimpleBarrel",
  props: {
    customerName: String,
    customerPhoneNumber: String,
    pybNumber: String,
    capacity: String,
    status: String,
    fullness: String,
    date: String,
    barrelNum: String,
    showRemoval: {
      type: Boolean,
      default: true,
    },
    removeRetailPackaging: {
      type: Boolean,
      default: null,
    },
    barrelSize: {
      type: String,
      default: "",
    },
    barrelName: {
      type: String,
      required: false,
    },
    showName: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    defaultBadgeClass: "badge badge-light-success mr-3",
  }),
  methods: {
    yesNo(value: boolean) {
      return value ? "Yes" : "No";
    },
  },

  computed: {
    statusBadgeClass(): string {
      const defaultClass = "badge mr-3";
      return this.status === "Barrel Held"
        ? `badge-light-warning ${defaultClass}`
        : `badge-light-success ${defaultClass}`;
    },
    name(): string {
      return this.barrelName ?? "Barrel Name";
    },
    formattedDate(): string {
      return formatDate(this.$props.date);
    },
    fullnessNumber(): string {
      if (!this.fullness) return "0";
      return this.fullness.replace("%", "");
    },
    showItemPrompt(): boolean {
      const invalidStatuses = ["In Cart", "Payment Pending"];

      return !invalidStatuses.includes(this.status);
    },
  },
});
